const Roles = Object.freeze({
  ctouch: "CTOUCH",
  user: "Customer",
  reseller: "Reseller"
});

export default Roles